import ZariTable from './table'
import ZariTable_Addons_Dropdown from './addons/dropdown'
import ZariTableRow from './row'
import ZariTableCell from './cell'

import ZariTable_ServerSide from './serverSide'
import ZariTable_ClientSide from './clientSide'

ZariTable.Dropdown = ZariTable_Addons_Dropdown
ZariTable.Row = ZariTableRow
ZariTable.Cell = ZariTableCell
ZariTable.ServerSide = ZariTable_ServerSide
ZariTable.ClientSide = ZariTable_ClientSide

export default ZariTable
